import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import PageHeader from "../../components/PageHeader";
import MessagesTable from "../../components/Tables/MessagesTable";
import withPermissions from "../../components/WithPermissions";

class Messages extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div
        style={{ flex: 1 }}
        onClick={() => {
          document.body.classList.remove("offcanvas-active");
        }}
      >
        <div>
          <div className="container-fluid">
            <PageHeader HeaderText="Mesajlar" Breadcrumb={[{ name: "Mesajlar" }]} />
            <div className="row clearfix">
              <div className="col-lg-12 col-md-12">
                <div className="card planned_task">
                  <div className="header">
                    <h2>Mesajlar</h2>
                  </div>
                  <div className="body">
                    <MessagesTable />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withPermissions(connect()(withRouter(Messages)));

